module.exports = __webpack_public_path__ + "static/media/Hero_Image_Desktop_5.3e9c17f3.jpg";